(ns viesti.frontend.tools
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/FormControlLabel$default" :as FormControlLabel]
            ["@mui/material/Radio$default" :as Radio]
            ["@mui/material/RadioGroup$default" :as RadioGroup]
            [fipp.edn :as edn]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [viesti.fsm :as vf]))

(defn code [source options]
  (when source
    [:pre {:style (merge {:padding "10px", :font-size "10px" :background "#fffbe6"} options)}
     (with-out-str (edn/pprint source))]))

(defn chip [props] [:> Chip props])

(defn feature [name] [chip {:label (pr-str name), :color "default"}])
(defn permission [name] [chip {:label (pr-str name), :color "info"}])
(defn state [name] [chip {:label (pr-str name), :color "primary"}])
(defn fsm [name] [chip {:label (pr-str name), :color "primary"}])

(defn cqrs-view []
  (r/with-let [_ (rf/dispatch [:cqrs/send [:system/actions]])
               _ (rf/dispatch [:cqrs/send [:system/available-actions]])]
    (let [actions (:value @(rf/subscribe [:cqrs/get :system/actions]))
          available (:value @(rf/subscribe [:cqrs/get :system/available-actions]))]
      [:div
       [:strong "CQRS"]
       [:hr]
       [:table {:cellPadding "5px"}
        [:thead
         [:tr
          [:th "Action"]
          [:th "Kind"]
          [:th "Requirements"]
          [:th "Description"]]]
        [:tbody.ant-table-tbody
         (doall (for [[k {:keys [kind description features permissions input]}] (sort actions)
                      :let [errors (get available k)]]
                  [:tr {:key (str k)}
                   [:td {:valign "top"}
                    [:> Button
                     {:variant (if (or errors input) "outlined" "contained")
                      :disabled (boolean errors)
                      :color (if (= :command kind) "error" "primary")
                      :on-click #(rf/dispatch [:cqrs/send {:type k}])}
                     (str (pr-str k) (when input "*"))]]
                   [:td {:valign "top"} kind]
                   [:td {:valign "top"}
                    (for [p permissions] ^{:key p} [permission p])
                    (for [f features] ^{:key f} [feature f])]
                   [:td {:valign "top"} description]]))]]])))

(defn -event-value [?e]
  (cond (array? ?e) (js->clj ?e)
        (some? ?e) (if-let [target (.-target ?e)]
                     (let [value (.-value target)
                           checked (.-checked target)]
                       (cond (some? value) value
                             (some? checked) checked
                             :else ?e)) ?e)))

(def fsm-mode* (r/atom "flow"))

(defn fsm-view []
  (r/with-let [_ (rf/dispatch [:cqrs/send [:fsm/flows]])]
    (let [machines @(rf/subscribe [:cqrs/get :fsm/flows])]
      [:div
       [:strong "FSMs"]
       [:hr]
       [:div {:style {:padding "10px"}}
        [:> RadioGroup
         {:value @fsm-mode*
          :row true
          :on-change #(reset! fsm-mode* (-event-value %))}
         (for [o ["flow" "normalized" "statechart"]]
           [:> FormControlLabel
            {:key o
             :value o
             :label o
             :control (r/as-element [:> Radio])}])]]
       [:table {:cellPadding "5px"}
        [:thead
         [:tr
          [:th "ID"]
          [:th "Data"]]]
        [:tbody
         (for [[k data] machines]
           (let [data (case @fsm-mode*
                        "flow" data
                        "normalized" (vf/-normalize data)
                        "statechart" (vf/-statechart data))]
             [:tr {:key (str k)}
              [:td {:valign "top"} [fsm k]]
              [:td {:valign "top"} [code data {:background "#f0f5ff"}]]]))]]])))

(defn states-view []
  (r/with-let [_ (rf/dispatch [:cqrs/send [:fsm/states]])]
    (let [states @(rf/subscribe [:cqrs/get :fsm/states])]
      [:div
       [:strong "States"]
       [:hr]
       [:table {:cellPadding "5px"}
        [:thead
         [:tr
          [:th "ID"]
          [:th "Type"]
          [:th "State"]
          [:th "Data"]]]
        [:tbody
         (for [[k {:keys [:example.backend.fsm/flow-id _state] :as data}] states]
           [:tr {:key (str k)}
            [:td {:valign "top"} (pr-str k)]
            [:td {:valign "top"} [fsm flow-id]]
            [:td {:valign "top"} [state _state]]
            [:td {:valign "top"} [code data {:background "#f0f5ff"}]]])]]])))

(defn permissions-view [permissions]
  [:div
   [:strong "Permissions"]
   [:hr]
   [:table {:cellPadding "5px"}
    [:thead
     [:tr
      [:th "Name"]
      [:th "Description"]]]
    [:tbody
     (doall (for [[k {:keys [description]}] (sort permissions)]
              [:tr {:key (str k)}
               [:td {:valign "top"} [permission k]]
               [:td {:valign "top"} description]]))]]])

(defn features-view [features]
  [:div
   [:strong "Features"]
   [:hr]
   [:table {:cellPadding "5px"}
    [:thead
     [:tr
      [:th "Name"]
      [:th "Description"]]]
    [:tbody
     (doall (for [[k {:keys [description]}] (sort features)]
              [:tr {:key (str k)}
               [:td {:valign "top"} [feature k]]
               [:td {:valign "top"} description]]))]]])

(defn create-panels
  [{:keys [permissions features cqrs fsm]}]
  [(when permissions {:key :permissions :label "Permissions" :view [permissions-view permissions]})
   (when features {:key :features :label "Features" :view [features-view features]})
   (when cqrs {:key :cqrs :label "CQRS" :view [cqrs-view]})
   (when fsm {:key :fsm :label "FSM" :view [fsm-view]})
   (when fsm {:key :states :label "States" :view [states-view]})])
